// Imports
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash };
    if (savedPosition) return savedPosition;

    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/home/Index.vue"),
      children: [
        {
          path: "",
          name: "Home",
          component: () => import("@/views/home/Index.vue"),
        },
        {
          path: "novels",
          name: "Novels",
          component: () => import("@/views/novels/Index.vue"),
          meta: { src: require("@/assets/Website background image roses.png") },
        },
        {
          path: "marianne",
          name: "Marianne",
          component: () => import("@/views/marianne/Index.vue"),
          meta: { src: require("@/assets/short-stories.jpg") },
        },
        {
          path: "marianne-content-guide",
          name: "Marianne Content Guide",
          component: () => import("@/views/marianne-content-guide/Index.vue"),
          meta: { src: require("@/assets/short-stories.jpg") },
        },
        {
          path: "marianne-annotations",
          name: "Marianne Annotations",
          component: () => import("@/views/marianne-annotations/Index.vue"),
          meta: { src: require("@/assets/short-stories.jpg") },
        },
        {
          path: "marianne-annotations/01",
          name: "Marianne Chapter 1 Annotated",
          component: () => import("@/views/marianne-annotations/01.vue"),
        },
        {
          path: "marianne-annotations/02",
          name: "Marianne Chapter 2 Annotated",
          component: () => import("@/views/marianne-annotations/02.vue"),
        },
        {
          path: "marianne-annotations/03",
          name: "Marianne Chapter 3 Annotated",
          component: () => import("@/views/marianne-annotations/03.vue"),
        },
        {
          path: "marianne-annotations/04",
          name: "Marianne Chapter 4 Annotated",
          component: () => import("@/views/marianne-annotations/04.vue"),
        },
        {
          path: "marianne-annotations/05",
          name: "Marianne Chapter 5 Annotated",
          component: () => import("@/views/marianne-annotations/05.vue"),
        },
        {
          path: "marianne-annotations/06",
          name: "Marianne Chapter 6 Annotated",
          component: () => import("@/views/marianne-annotations/06.vue"),
        },
        {
          path: "marianne-annotations/07",
          name: "Marianne Chapter 7 Annotated",
          component: () => import("@/views/marianne-annotations/07.vue"),
        },
        {
          path: "marianne-annotations/08",
          name: "Marianne Chapter 8 Annotated",
          component: () => import("@/views/marianne-annotations/08.vue"),
        },
        {
          path: "marianne-annotations/09",
          name: "Marianne Chapter 09 Annotated",
          component: () => import("@/views/marianne-annotations/09.vue"),
        },
        {
          path: "marianne-annotations/10",
          name: "Marianne Chapter 10 Annotated",
          component: () => import("@/views/marianne-annotations/10.vue"),
        },
        {
          path: "marianne-annotations/11",
          name: "Marianne Chapter 11 Annotated",
          component: () => import("@/views/marianne-annotations/11.vue"),
        },
        {
          path: "marianne-annotations/12",
          name: "Marianne Chapter 12 Annotated",
          component: () => import("@/views/marianne-annotations/12.vue"),
        },
        {
          path: "marianne-annotations/13",
          name: "Marianne Chapter 13 Annotated",
          component: () => import("@/views/marianne-annotations/13.vue"),
        },
        {
          path: "marianne-annotations/14",
          name: "Marianne Chapter 14 Annotated",
          component: () => import("@/views/marianne-annotations/14.vue"),
        },
        {
          path: "marianne-annotations/15",
          name: "Marianne Chapter 15 Annotated",
          component: () => import("@/views/marianne-annotations/15.vue"),
        },
        {
          path: "marianne-annotations/16",
          name: "Marianne Chapter 16 Annotated",
          component: () => import("@/views/marianne-annotations/16.vue"),
        },
        {
          path: "marianne-annotations/17",
          name: "Marianne Chapter 17 Annotated",
          component: () => import("@/views/marianne-annotations/17.vue"),
        },
        {
          path: "marianne-annotations/18",
          name: "Marianne Chapter 18 Annotated",
          component: () => import("@/views/marianne-annotations/18.vue"),
        },
        {
          path: "marianne-annotations/19",
          name: "Marianne Chapter 19 Annotated",
          component: () => import("@/views/marianne-annotations/19.vue"),
        },
        {
          path: "marianne-annotations/20",
          name: "Marianne Chapter 20 Annotated",
          component: () => import("@/views/marianne-annotations/20.vue"),
        },
        {
          path: "marianne-annotations/21",
          name: "Marianne Chapter 21 Annotated",
          component: () => import("@/views/marianne-annotations/21.vue"),
        },
        {
          path: "marianne-annotations/22",
          name: "Marianne Chapter 22 Annotated",
          component: () => import("@/views/marianne-annotations/22.vue"),
        },
        {
          path: "marianne-annotations/23",
          name: "Marianne Chapter 23 Annotated",
          component: () => import("@/views/marianne-annotations/23.vue"),
        },
        {
          path: "marianne-annotations/24",
          name: "Marianne Chapter 24 Annotated",
          component: () => import("@/views/marianne-annotations/24.vue"),
        },
        {
          path: "marianne-annotations/25",
          name: "Marianne Chapter 25 Annotated",
          component: () => import("@/views/marianne-annotations/25.vue"),
        },
        {
          path: "marianne-annotations/26",
          name: "Marianne Chapter 26 Annotated",
          component: () => import("@/views/marianne-annotations/26.vue"),
        },
        {
          path: "marianne-annotations/27",
          name: "Marianne Chapter 27 Annotated",
          component: () => import("@/views/marianne-annotations/27.vue"),
        },
        {
          path: "marianne-annotations/28",
          name: "Marianne Chapter 28 Annotated",
          component: () => import("@/views/marianne-annotations/28.vue"),
        },
        {
          path: "marianne-annotations/29",
          name: "Marianne Chapter 29 Annotated",
          component: () => import("@/views/marianne-annotations/29.vue"),
        },
        {
          path: "marianne-annotations/30",
          name: "Marianne Chapter 30 Annotated",
          component: () => import("@/views/marianne-annotations/30.vue"),
        },
        {
          path: "marianne-annotations/31",
          name: "Marianne Chapter 8 Annotated",
          component: () => import("@/views/marianne-annotations/31.vue"),
        },
        {
          path: "marianne-annotations/epilogue",
          name: "Marianne Epilogue Annotated",
          component: () => import("@/views/marianne-annotations/epilogue.vue"),
        },
        {
          path: "short-stories",
          name: "Short Stories",
          component: () => import("@/views/short-stories/Index.vue"),
          meta: { src: require("@/assets/Website background image wreath.png") },
        },
        {
          path: "anna-and-the-ghost",
          name: "Anna and the Ghost",
          component: () => import("@/views/anna-and-the-ghost/Index.vue"),
          meta: { src: require("@/assets/covers/anna-and-the-ghost.jpg") },
        },
        {
          path: "adopting-from-mars",
          name: "Adopting from Mars",
          component: () => import("@/views/adopting-from-mars/Index.vue"),
          meta: { src: require("@/assets/covers/adopting-from-mars.jpg") },
        },
        {
          path: "daphne-and-the-dragon",
          name: "Daphne and the Dragon",
          component: () => import("@/views/daphne-and-the-dragon/Index.vue"),
          meta: { src: require("@/assets/covers/daphne-and-the-dragon.jpg") },
        },
        // {
        //   path: 'about',
        //   name: 'About',
        //   component: () => import('@/views/about/Index.vue'),
        //   meta: { src: require('@/assets/about.jpg') },
        // },
        // {
        //   path: 'contact-us',
        //   name: 'Contact',
        //   component: () => import('@/views/contact-us/Index.vue'),
        //   meta: { src: require('@/assets/contact.jpg') },
        // },
        // {
        //   path: 'pro',
        //   name: 'Pro',
        //   component: () => import('@/views/pro/Index.vue'),
        //   meta: { src: require('@/assets/pro.jpg') },
        // },
        // {
        //   path: '*',
        //   name: 'FourOhFour',
        //   component: () => import('@/views/404/Index.vue'),
        // },
      ],
    },
  ],
});

export default router;
